import { Injectable, inject } from '@angular/core';
import { getArrayOrEmptyArray } from 'src/app/core/array-utils';
import { FeedbackService } from 'src/app/core/feedback/feedback.service';
import { getIsNotNullable } from 'src/app/core/nullable-utils';
import { ProjectService } from 'src/app/core/services/project.service';
import { NotificationEntryInputDto, NotificationStore } from './state/notification.store';

type NotificationToMarkAsSeen = Pick<NotificationEntryInputDto, 'id'>;

@Injectable({
  providedIn: 'root',
})
export class NotificationDataService {
  readonly notificationStore = inject(NotificationStore);
  readonly #projectService = inject(ProjectService);
  readonly #feedbackService = inject(FeedbackService);

  constructor() {
    this.notificationStore.loadByProjectId(this.#projectService.currentProjectId);
  }

  async markAsSeen(notifications: NotificationToMarkAsSeen): Promise<void>;
  async markAsSeen(notifications: NotificationToMarkAsSeen[]): Promise<void>;
  async markAsSeen(notifications: NotificationToMarkAsSeen | NotificationToMarkAsSeen[]): Promise<void> {
    const notificationsToPatch = getArrayOrEmptyArray(notifications).map(({ id }) => ({ id, seen: true }));
    const projectId = this.#projectService.currentProjectId();
    if (getIsNotNullable(projectId)) {
      return this.notificationStore.updateNotifications({
        projectId,
        patches: notificationsToPatch,
      });
    }

    return Promise.reject(
      this.#feedbackService.showErrorWithTitle({
        title: 'Failed to toggle seen state',
        message: 'Invalid project.',
      }),
    );
  }
}
